<h2 mat-dialog-title>{{ 'FRONTEND.SALES_UI.PIPELINE.PIPELINES' | translate }}</h2>
<mat-dialog-content>
  <mat-form-field class="full-width">
    <mat-label>{{ 'FRONTEND.SALES_UI.PIPELINE.PIPELINES' | translate }}</mat-label>
    <mat-select
      (selectionChange)="setCheckedPipelines($event.value)"
      [compareWith]="pipelineIdComparison"
      [formControl]="pipelineControl"
      multiple
    >
      <ng-container *ngFor="let pipeline of selectablePipelines$ | async">
        <mat-option [value]="pipeline">{{ pipeline.name }}</mat-option>
      </ng-container>
    </mat-select>
  </mat-form-field>
  <mat-form-field class="full-width">
    <mat-label>{{ 'FRONTEND.SALES_UI.PIPELINE.PIPELINE_STAGE_LABEL' | translate }}</mat-label>
    <mat-select
      (selectionChange)="setSelectedPipelineStage($event.value)"
      [formControl]="pipelineStageControl"
      [matTooltipDisabled]="(checkedPipelinesIds$ | async)?.length === 1"
      [matTooltip]="'FRONTEND.SALES_UI.PIPELINE.PIPELINE_STAGE_TOOLTIP' | translate"
    >
      <ng-container *ngFor="let pipelineStage of selectablePipelinesStages$ | async">
        <mat-option [value]="pipelineStage">
          {{ pipelineStage.name }}
        </mat-option>
      </ng-container>
    </mat-select>
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button color="primary" mat-button mat-dialog-close>
    {{ 'FRONTEND.SALES_UI.COMMON.ACTION_LABELS.CANCEL' | translate }}
  </button>
  <button
    (click)="handlePipelineSelection(selectedPipelines)"
    *ngIf="checkedPipelinesIds$ | async as selectedPipelines"
    color="primary"
    mat-raised-button
  >
    {{ 'FRONTEND.SALES_UI.COMMON.ACTION_LABELS.SAVE' | translate }}
  </button>
</mat-dialog-actions>
